export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9344.9a48983b.jpg";